import React, { useEffect, useRef } from 'react';
export const AboutUs = () => {
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('opacity-100');
        entry.target.classList.remove('opacity-0', 'translate-y-10');
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section id="about" className="py-20 bg-white" data-id="element-15">
      <div className="container mx-auto px-4" data-id="element-16">
        <div ref={sectionRef} className="flex flex-col md:flex-row items-center transition-all duration-1000 opacity-0 translate-y-10" data-id="element-17">
          {/* Image side */}
          <div className="w-full md:w-1/2 mb-10 md:mb-0" data-id="element-18">
            <div className="relative" data-id="element-19">
              <div className="absolute -top-4 -left-4 w-64 h-64 border-2 border-gold" data-id="element-20"></div>
              <img src="https://i.pinimg.com/1200x/8f/fe/cc/8ffecc0aec79bd897be4a2467b94e422.jpg" alt="Niqqanno Consulting Team" className="w-full h-auto object-cover relative z-10" data-id="element-21" />
            </div>
          </div>
          {/* Content side */}
          <div className="w-full md:w-1/2 md:pl-16" data-id="element-22">
            <h2 className="text-primary font-serif text-3xl md:text-4xl font-bold mb-6" data-id="element-23">
              About Niqqanno Consulting
            </h2>
            <div className="w-20 h-1 bg-gold mb-8" data-id="element-24"></div>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-25">
              Niqqanno Consulting stands at the intersection of legal expertise
              and business strategy, offering unparalleled services to
              growth-focused companies across industries.
            </p>
            <p className="text-gray-700 mb-8 leading-relaxed" data-id="element-26">
              Founded on principles of excellence and integrity, our dual
              expertise in Corporate Law and Business Strategy allows us to
              provide comprehensive solutions that protect and propel your
              business forward.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-27">
              <div className="border-l-2 border-gold pl-4" data-id="element-28">
                <h3 className="text-primary font-bold mb-2" data-id="element-29">5+ Years</h3>
                <p className="text-gray-600" data-id="element-30">Industry Experience</p>
              </div>
              <div className="border-l-2 border-gold pl-4" data-id="element-31">
                <h3 className="text-primary font-bold mb-2" data-id="element-32">100+</h3>
                <p className="text-gray-600" data-id="element-33">Successful Clients</p>
              </div>
              <div className="border-l-2 border-gold pl-4" data-id="element-34">
                <h3 className="text-primary font-bold mb-2" data-id="element-35">98%</h3>
                <p className="text-gray-600" data-id="element-36">Client Retention</p>
              </div>
              <div className="border-l-2 border-gold pl-4" data-id="element-37">
                <h3 className="text-primary font-bold mb-2" data-id="element-38">Global</h3>
                <p className="text-gray-600" data-id="element-39">Service Reach</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};